<template>
  <router-view />
</template>
  
<script>
export default {
  name: "FittingMain",
};
</script>